import React from 'react';
import styled from 'styled-components';
import { Card } from '../Card';
import { Stack } from '../Stack';
import { Text } from '../Text';
import { theme } from '../../theme';
import { Info, CheckCircleOutline, BagFilled, AlertFilled } from '../../icons';
export var AlertTagVariants;
(function (AlertTagVariants) {
    AlertTagVariants["primary"] = "primary";
    AlertTagVariants["info"] = "info";
    AlertTagVariants["alert"] = "alert";
    AlertTagVariants["softAlert"] = "softAlert";
    AlertTagVariants["error"] = "error";
    AlertTagVariants["success"] = "success";
})(AlertTagVariants || (AlertTagVariants = {}));
export var AlertTagIcons;
(function (AlertTagIcons) {
    AlertTagIcons["info"] = "info";
    AlertTagIcons["check"] = "check";
    AlertTagIcons["bag"] = "bag";
    AlertTagIcons["alert"] = "alert";
})(AlertTagIcons || (AlertTagIcons = {}));
const alertTagBackgroundColors = {
    [AlertTagVariants.primary]: theme.colors.gray100,
    [AlertTagVariants.info]: theme.colors.blue,
    [AlertTagVariants.alert]: theme.colors.mangoLight,
    [AlertTagVariants.error]: theme.colors.error,
    [AlertTagVariants.softAlert]: theme.colors.mangoLightSupport,
    [AlertTagVariants.success]: theme.colors.success,
};
const alertTagContentColors = {
    [AlertTagVariants.primary]: 'gray700',
    [AlertTagVariants.info]: 'blueberryDarkSupport',
    [AlertTagVariants.alert]: 'mangoDarkSupport',
    [AlertTagVariants.error]: 'white',
    [AlertTagVariants.softAlert]: 'mangoDarkSupport',
    [AlertTagVariants.success]: 'white',
};
const getAlertTagIcon = (icon, color) => {
    const alertTagIcons = {
        [AlertTagIcons.info]: React.createElement(Info, { color: color, size: "x3" }),
        [AlertTagIcons.check]: React.createElement(CheckCircleOutline, { color: color, size: "x3" }),
        [AlertTagIcons.bag]: React.createElement(BagFilled, { color: color, size: "x3" }),
        [AlertTagIcons.alert]: React.createElement(AlertFilled, { color: color, size: "x3" }),
    };
    return alertTagIcons[icon];
};
const Component = styled(Card)(({ variant }) => `
    display: flex;
    align-items: center;
    border: 0;
    background-color: ${alertTagBackgroundColors[variant]};
  `);
const IconContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const AlertTag = ({ content, variant = AlertTagVariants.primary, icon = AlertTagIcons.info, iconColor, hasPseudoAfter = true, }) => {
    const contentColor = alertTagContentColors[variant];
    return (React.createElement(Component, { py: "x16", px: "x16", variant: variant, hasPseudoAfter: hasPseudoAfter },
        React.createElement(Stack, { layout: "horizontal", margin: "x8" },
            React.createElement(IconContainer, null, getAlertTagIcon(icon, iconColor || contentColor)),
            typeof content === 'string' ? (React.createElement(Text, { textSize: "x14", color: contentColor }, content)) : (content))));
};
//# sourceMappingURL=index.js.map